module.exports = __webpack_public_path__ + "static/media/iconTransmission.30e257a6.svg";